// extracted by mini-css-extract-plugin
export default {"container":"TagPage_container__eTp9n","textContainer":"TagPage_textContainer__bzmVY","productCard":"TagPage_productCard__+q45S"};